import LangLink from "./LangLink";
import { ArrowUpRight } from "lucide-react";

const base =
  "inline-flex items-center justify-center gap-2 rounded-full font-sans font-medium transition-all duration-300 focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-background active:scale-[0.97] disabled:opacity-60 disabled:pointer-events-none";

const sizes = {
  md: "px-7 py-3.5 text-[15px]",
  lg: "px-9 py-4 text-base",
  sm: "px-5 py-2.5 text-sm",
};

const variants = {
  primary: "bg-primary text-primary-foreground hover:bg-primary/90 hover:-translate-y-0.5",
  accent: "bg-accent text-accent-foreground hover:brightness-105 hover:-translate-y-0.5",
  outline: "border border-primary/25 text-primary hover:border-accent hover:bg-surface",
  ghost: "text-primary hover:text-accent",
};

// Polymorphic CTA: renders an internal LangLink, external <a>, or <button>.
export default function CTAButton({
  children,
  to,
  href,
  onClick,
  type = "button",
  variant = "primary",
  size = "md",
  arrow = false,
  className = "",
  testId,
  ...rest
}) {
  const cls = `${base} ${sizes[size]} ${variants[variant]} ${className}`;
  const content = (
    <>
      {children}
      {arrow && <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />}
    </>
  );

  if (to) {
    return (
      <LangLink to={to} className={cls} data-testid={testId} {...rest}>
        {content}
      </LangLink>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} data-testid={testId} target={rest.target} rel={rest.rel}>
        {content}
      </a>
    );
  }
  return (
    <button type={type} onClick={onClick} className={cls} data-testid={testId} {...rest}>
      {content}
    </button>
  );
}
